<template>
<div class="ti d-flex">
    <div class="d-flex-left">
      <erp-project @node-click="nodeClick"></erp-project>
    </div>

    <div class="d-flex-right">
      <el-button size="mini" type="primary text2"  @click="zingzheng" v-if="ERP.isPermission(4001001001)">新增</el-button>
      <el-button size="mini" type="primary text2" @click="searchs">搜索</el-button>
      <el-button size="mini" type="primary text2" @click="projectCopy">按项目复制</el-button>
      <div>
        <el-descriptions :column="2" border size="mini" style="margin-top: 10px;" :labelStyle="{width: '123px'}" :contentStyle="{width:'42%'}">
          <el-descriptions-item  label="选择项目">
            <el-select size="mini" v-model="pindex_id" filterable clearable placeholder="选择项目" style="width:100%">
              <el-option key="" label="全部" value=""></el-option>
              <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-descriptions-item>
          <el-descriptions-item label="收入类型">
            <el-select v-model="ChargeItemInTypeID" size="mini" clearable multiple filterable collapse-tags style="width:100%" placeholder="收入类型">
             <el-option v-for="(item,index) in list2" :key="item.id" :label="item.name" :value="item.id" v-if="index != 0"></el-option>
           </el-select>
          </el-descriptions-item>
          <el-descriptions-item label="费用类别">
            <el-select v-model="ChargeItemClassID" size="mini" clearable multiple filterable collapse-tags style="width:100%" placeholder="费用类别">
              <el-option v-for="(item,index) in list1" :key="item.id" :label="item.name" :value="item.id" v-if="index != 0"></el-option>
            </el-select>
          </el-descriptions-item>
          <el-descriptions-item label="收费类型">
            <el-select v-model="ChargeitemNameId" size="mini" clearable multiple filterable collapse-tags style="width:100%" placeholder="收费类型">
              <el-option v-for="item in types" :key="item.id" :label="item.chargeItem_name" :value="item.id"></el-option>
            </el-select>
          </el-descriptions-item>
          <el-descriptions-item label="搜索名称">
            <el-input size="mini" style="width:100%" placeholder="请输入搜索名称" v-model="search" clearable></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="">
          </el-descriptions-item>
        </el-descriptions>
      </div>
       <div style="margin-top:10px">
         <el-table ref="multipleTable" :data="desserts" border tooltip-effect="dark" style="width: 100%" height="56vh">
           <el-table-column prop="sort" label="序号" width="80"></el-table-column>
           <el-table-column prop="id" label="ID" width="80"></el-table-column>
           <el-table-column prop="name" label="名称" width="200"></el-table-column>
           <el-table-column prop="chargeItem_name" label="收费类型" width="120"></el-table-column>
           <el-table-column prop="pindex_name" label="项目" show-overflow-tooltip></el-table-column>
           <el-table-column prop="charge" label="费用" width="100"></el-table-column>
           <el-table-column prop="charge1" label="税率" width="100"></el-table-column>
           <el-table-column prop="founder" label="创建人" width="100"></el-table-column>
           <el-table-column prop="reviser" label="修改人" width="100"></el-table-column>
           <el-table-column prop="date" label="日期" width="160"></el-table-column>
           <el-table-column label="操作" width="180">
             <template slot-scope="scope">
               <span class="cdj_td">
                 <div style="color: #1867c0;cursor: pointer;" @click="xiugai( scope.row.id,scope.row.company_id)" v-if="ERP.isPermission(4001001005)">修改</div>
                 <span v-if="scope.row.fixed !=1 ">
                   <div  style="color: red;margin-left: 5px;;cursor: pointer;" @click="del( scope.row.id)" v-if="ERP.isPermission(4001001006)">删除</div>
                 </span>
               </span>
             </template>
           </el-table-column>
         </el-table>
       </div>
       <div class="pages" v-if="desserts">
         <Page :total="total" :page-size="page" @on-change="change"  show-total />
       </div>
       <div class="zhanwu" v-else>没有数据</div>
    </div>

    <!-- 新增和修改 -->
    <Modal
        v-model="modal1axing"
        ok-text="保存"
        width="80%"
        :styles="{'position': 'absolute','top':'20px','left':'10%'}"
        title="添加收费项"
        :loading="loadingModal"
        @on-ok="oks">
        <el-form  label-width="80px" style="height: 660px;overflow: auto;">
          <el-row>
            <el-col :span="1">
              <el-form-item label="">
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <div style="font-size: 15px;margin-bottom: 20px;color: #000;">收费标准设置1</div>
              <el-form-item label="名称" :rules="[{required: true}]">
                <el-input v-model="dades.name" placeholder="名称"></el-input>
              </el-form-item>
              <el-form-item label="选择项目" :rules="[{required: true}]">
                <el-select style="width: 100%;" v-model="dades.pindex_id" filterable placeholder="请选择项目">
                  <el-option
                    v-for="item in options"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="收入类型">
                <el-select style="width: 100%;" v-model="dades.ChargeItemInTypeID" @change="char()" filterable placeholder="选择收费类型">
                  <el-option
                    v-for="item in list2"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="费用类别">
                <el-select style="width: 100%;" v-model="dades.ChargeItemClassID" @change="char()" filterable placeholder="选择费用类别">
                  <el-option
                    v-for="item in list1"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="收费类型" :rules="[{required: true}]">
                <el-select style="width: 100%;" v-model="dades.chargeItem_name_id" filterable placeholder="选择收费类型">
                  <el-option
                    v-for="item in types"
                    :key="item.id"
                    :label="item.chargeItem_name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <span class="zhujie">单位（元，如填写3.26，3.26元）</span>
              <el-form-item label="金额" :rules="[{required: true}]">
                <el-input v-model="dades.charge"></el-input>
              </el-form-item>
              <!-- <div v-if="dades.type != 5"> -->
              <div>
                <span class="zhujie">单位（%）</span>
                <el-form-item label="税率" :rules="[{required: true}]">
                  <el-input v-model="dades.charge1"></el-input>
                </el-form-item>
                <el-form-item label="发票征收方式" label-width="100px">
                  <el-radio v-model="dades.tax_rate_type" :label="0">正常征收</el-radio>
                  <el-radio v-model="dades.tax_rate_type" :label="1">简易征收</el-radio>
                </el-form-item>
                <el-form-item label="收费方式">
                  <el-switch v-model="dades.types"></el-switch>&nbsp;&nbsp;&nbsp;<span v-if="dades.types==false">按天计算</span><span v-else>按月计算</span>
                </el-form-item>
                <span class="zhujie" v-if="dades.types==false">一次生成一个月，费用按天计算。</span>
                <span class="zhujie" v-if="dades.types==true">一次生成一个月，费用按月计算</span>
                <!-- 房产 -->
                <el-form-item label="收费公式" :rules="[{required: true}]">
                  <el-select v-model="dades.area" filterable placeholder="请选择公式">
                    <el-option label="费用=金额*套内面积" value="1"></el-option>
                    <el-option label="费用=金额*计费面积" value="2"></el-option>
                    <el-option label="费用=金额*花园面积" value="3"></el-option>
                    <el-option label="费用=金额*分摊面积" value="4"></el-option>
                    <el-option label="费用=金额" value="5"></el-option>
                  </el-select>
                </el-form-item>
              </div>

              <el-form-item label="应收精确" :rules="[{required: true}]">
                <el-radio v-model="dades.receivable" label="1">分</el-radio>
                <el-radio v-model="dades.receivable" label="2">角</el-radio>
                <el-radio v-model="dades.receivable" label="3">元</el-radio>
              </el-form-item>
              <el-form-item label="应收尾数" :rules="[{required: true}]">
                <el-radio v-model="dades.receivable_calculation" label="1">四舍五入</el-radio>
                <el-radio v-model="dades.receivable_calculation" label="2">去掉零头</el-radio>
              </el-form-item>
              <el-form-item label="实收精确" :rules="[{required: true}]">
                <el-radio v-model="dades.receipts" label="1">分</el-radio>
                <el-radio v-model="dades.receipts" label="2">角</el-radio>
                <el-radio v-model="dades.receipts" label="3">元</el-radio>
              </el-form-item>
              <el-form-item label="实收尾数" :rules="[{required: true}]">
                <el-radio v-model="dades.receipts_calculation" label="1">不做处理</el-radio>
                <el-radio v-model="dades.receipts_calculation" label="2">四舍五入</el-radio>
                <el-radio v-model="dades.receipts_calculation" label="3">去掉零头</el-radio>
              </el-form-item>
              <el-form-item label="备注">
                <el-input v-model="dades.remarks"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="1">
              <el-form-item label="">
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <div style="font-size: 15px;margin-bottom: 20px;color: #000;">房产状态自动费用折扣设置(只针对常规收费项目) </div>
              <el-form-item label="空置">
                <el-input v-model="dades.dis_count_percent_expression_1" placeholder="请输入公式"></el-input>
              </el-form-item>
              <el-form-item label="未领">
                <el-input v-model="dades.dis_count_percent_expression_2" placeholder="请输入公式"></el-input>
              </el-form-item>
              <el-form-item label="空关">
                <el-input v-model="dades.dis_count_percent_expression_3" placeholder="请输入公式"></el-input>
              </el-form-item>
              <el-form-item label="装修">
                <el-input v-model="dades.dis_count_percent_expression_4" placeholder="请输入公式"></el-input>
              </el-form-item>
              <el-form-item label="入住">
                <el-input v-model="dades.dis_count_percent_expression_5" placeholder="请输入公式"></el-input>
              </el-form-item>
              <el-form-item label="出租">
                <el-input v-model="dades.dis_count_percent_expression_6" placeholder="请输入公式"></el-input>
              </el-form-item>
              <el-form-item label="保存类型">
                <el-radio v-model="dades.save_for_virtual" :label="0">折扣金额</el-radio>
                <el-radio v-model="dades.save_for_virtual" :label="1">虚增应收</el-radio>
              </el-form-item>
              <el-form-item label="不产生虚增应收的对应房态">
                <el-checkbox-group :disabled="dades.save_for_virtual===0" v-model="dades.room_status_for_virtual">
                  <el-checkbox label="0">装修</el-checkbox>
                  <el-checkbox label="1">入住</el-checkbox>
                  <el-checkbox label="2">出租</el-checkbox>
                  <el-checkbox label="3">未领</el-checkbox>
                  <el-checkbox label="4">空关</el-checkbox>
                </el-checkbox-group>
              </el-form-item>
              <el-form-item label="虚增应收的房态变化类型">
                <el-radio :disabled="dades.save_for_virtual===0" v-model="dades.room_status_change_type_for_virtual" :label="0">当月任何一天房态改变，当月不享受折让</el-radio>
                <el-radio :disabled="dades.save_for_virtual===0" v-model="dades.room_status_change_type_for_virtual" :label="1">收费周期内任何一天房态改变，当前收费周期不享受折让</el-radio>
                <el-radio :disabled="dades.save_for_virtual===0" v-model="dades.room_status_change_type_for_virtual" :label="1">当月任何一天房态改变，第2天开始不享受折让</el-radio>
                <el-radio :disabled="dades.save_for_virtual===0" v-model="dades.room_status_change_type_for_virtual" :label="1">当月任何一天房态改变，当天开始不享受折让</el-radio>
              </el-form-item>

              <div style="font-size: 15px;margin-bottom: 20px;color: #000;">违约金</div>
              <el-form-item label="是否收取" label-width="90px">
                <el-radio v-model="dades.is_delay" :label="0">否</el-radio>
                <el-radio v-model="dades.is_delay" :label="1">是</el-radio>
              </el-form-item>
              <el-form-item label="违约金比例" label-width="90px">
                <el-input :disabled="dades.is_delay===0" v-model="dades.rate" style="width: 80%;" placeholder="违约金比例"></el-input>
                <span style="margin-left: 3px;">%</span>
              </el-form-item>
              <el-form-item label="减免选择" label-width="90px">
                <el-radio :disabled="dades.is_delay===0" v-model="dades.is_delay_days" :label="1">按天减免</el-radio>
                <el-radio :disabled="dades.is_delay===0" v-model="dades.is_delay_days" :label="0">按月减免</el-radio>
              </el-form-item>
              <el-form-item label="减免天数" label-width="90px" v-if="dades.is_delay_days == 1">
                <el-input :disabled="dades.is_delay===0" v-model="dades.derate_month_day" style="width: 80%;"></el-input>
                <span style="margin-left: 3px;">天</span>
              </el-form-item>
              <el-form-item label="减免月数" label-width="90px" v-if="dades.is_delay_days == 0">
                <el-input :disabled="dades.is_delay===0" v-model="dades.derate_month_day" style="width: 80%;"></el-input>
                <span style="margin-left: 3px;">月</span>
              </el-form-item>
              <el-form-item label="开始时间 " label-width="90px">
                <el-radio :disabled="dades.is_delay===0" v-model="dades.delay_mode" :label="0">应收日期</el-radio>
                <el-radio :disabled="dades.is_delay===0" v-model="dades.delay_mode" :label="1">计费开始日期</el-radio>
                <el-radio :disabled="dades.is_delay===0" v-model="dades.delay_mode" :label="2">计费结束日期</el-radio>
              </el-form-item>
              <el-form-item label="生效时间 " label-width="90px">
                <el-date-picker :disabled="dades.is_delay===0" v-model="dades.delay_begin_date" type="date" placeholder="生效时间"></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
    </Modal>

  <Modal
    v-model="copy1axing"
    ok-text="保存"
    width="50%"
    :styles="{'position': 'absolute','top':'20px','left':'30%'}"
    title="复制"
    :loading="loadingCopy"
    @on-ok="copySave">
    <el-form label-width="80px" :model="copyData" style="height: 660px;overflow: auto;">
      <el-form-item label="来源项目" prop="pindex_id" :rules="{required: true, message: '来源项目不能空',trigger: 'blur',}">
        <el-select size="mini" v-model="copyData.pindex_id" filterable clearable placeholder="选择来源项目" style="width:100%">
          <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="目标项目" prop="new_pindex_id" :rules="{required: true, message: '目标项目不能空',trigger: 'blur',}">
        <el-select
          v-model="copyData.new_pindex_id"
          placeholder="请选择目标项目"
          clearable
          multiple
          filterable
        >
          <template #label="{ name, id }">
            <span>{{ name }}: </span>
            <span style="font-weight: bold">{{ id }}</span>
          </template>
          <el-option
            v-for="item in options"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="收费类型">
        <el-select
          v-model="copyData.chargeItem_name_id"
          placeholder="请选择收费类型"
          clearable
          multiple
          filterable
        >
          <template #label="{ chargeItem_name, id }">
            <span>{{ chargeItem_name }}: </span>
            <span style="font-weight: bold">{{ id }}</span>
          </template>
          <el-option
            v-for="item in types"
            :key="item.id"
            :label="item.chargeItem_name"
            :value="item.id"
          />
        </el-select>
      </el-form-item>
<!--      <el-form-item label="费用类别">-->
<!--        <el-select style="width: 100%;" v-model="copyData.ChargeItemClassID" @change="char()" filterable placeholder="选择费用类别">-->
<!--          <el-option-->
<!--            v-for="item in list1"-->
<!--            :key="item.id"-->
<!--            :label="item.name"-->
<!--            :value="item.id">-->
<!--          </el-option>-->
<!--        </el-select>-->
<!--      </el-form-item>-->
      <p>说明：</p>
      <p>1.该功能是把来源项目下面的收费标准复制到目标项目中</p>
      <p>2.命名规则是目标项目_收费标准名称</p>
      <p>3.选择收费项目，可将来源项目下的指定的收费项目复制到目标项目中</p>
      <p>4.选择收费标准，可将收费项目下指定的收费标准复制到目标项目中</p>
    </el-form>
  </Modal>
</div>
</template>

<script>
import ErpProject from "../Common/erp-project";
export default {
  name: 'pindexCharge',
  components: {ErpProject},
  data () {
    return {
      ChargeItemInTypeID:'',
      ChargeItemClassID:'',
      ChargeitemNameId:'',
     loadingModal:true,
     modal1add:false,
     modal1axing:false,
      copy1axing:false,
      loadingCopy:true,
     modal1:false,
     types:[],
     typesvalyel:'',
     activeName: '0',
     search:'',
     value:'',
     value1:'',
     pindex_id:'',
     desserts: '',
     total:12,
     page:1,
     cs:'',
     dades:{
       id:'',
       name:'',
       pindex_id:'',
       chargeItem_name_id:'',
       type:'',
       types:true,
       charge:'',
       charge1:'',
       area:'',
       remarks:'',
       receivable:'1',
       receivable_calculation:'1',
       receipts:'1',
       receipts_calculation:'2',
       ChargeItemInTypeID:'',
       ChargeItemClassID:'',
       dis_count_percent_expression_1:"费用_金额*1.00",
       dis_count_percent_expression_2:"费用_金额*1.00",
       dis_count_percent_expression_3:"费用_金额*1.00",
       dis_count_percent_expression_4:"费用_金额*1.00",
       dis_count_percent_expression_5:"费用_金额*1.00",
       dis_count_percent_expression_6:"费用_金额*1.00",
       save_for_virtual:0,
       room_status_for_virtual:[],
       room_status_change_type_for_virtual:0,
       is_delay:0,
       rate:0,
       is_delay_days:1,
       derate_month_day:0,
       delay_mode:0,
       delay_begin_date:'',
       tax_rate_type: 0
     },
      copyData:{
        pindex_id:[],
        new_pindex_id:[],
        chargeItem_name_id:[],
      },
      options: [],
     type:'',
     list1:[
       {
         id:0,
         name:"全部"
       },
       {
         id:1,
         name:"管理费收入"
       },
       {
         id:2,
         name:"车位收入"
       },
       {
         id:3,
         name:"其他业务收入"
       },
       {
         id:4,
         name:"代收代支"
       },

     ],
     list2:[
       {
         id:0,
         name:"全部"
       },
       {
         id:1,
         name:"营业收入"
       },
       {
         id:2,
         name:"非营业收入"
       }
     ],
    }
  },
  //界面没出来前加载
  created() {
  },
  mounted(){
    this.change(1);
    this.$myhttp.get('admin/common/pindex',{
      'Content-Type': 'application/json'
      }).then(backdata=>{
        this.options = backdata.data.data;
    });
    //加载收费大类（费项）
    this.$myhttp.get('admin/common/getChargeitem',{
      'Content-Type': 'application/json'
      }).then(backdata=>{
        this.types = backdata.data.data;
    });
  },
  computed:{
    __TABLE_HEIGHT__(){
      return ERP.getStore().__TABLE_HEIGHT__
    }
  },
  methods: {
    //更改收费类型
    char(){
      let ChargeItemClassID = this.dades.ChargeItemClassID;
      let ChargeItemInTypeID = this.dades.ChargeItemInTypeID;
      this.dades.chargeItem_name_id = '';
      this.$myhttp.get('admin/getChargeitems?ChargeItemClassID='+ChargeItemClassID+'&ChargeItemInTypeID='+ChargeItemInTypeID,{
        'Content-Type': 'application/json'
        }).then(backdata=>{
          this.types = backdata.data.data;
      });
    },
    //拉取新视窗收费项
    getXsc(){
      this.$myhttp.get('project/getChargeItem',{
        'Content-Type': 'application/json'
        }).then(backdata=>{

      });
    },
    //切换改变
    handleClick(tab, event) {
        this.activeName = tab.name;
        this.change(1);
    },
    //新增
    zingzheng(){
      if(this.dades.id){
        this.dades={
          id:'',
          name:'',
          pindex_id:'',
          chargeItem_name_id:'',
          type:'',
          types:false,
          charge:'',
          area:'',
          remarks:'',
          receivable:'',
          receivable_calculation:'',
          receipts:'',
          receipts_calculation:'',
          ChargeItemInTypeID:'',
          ChargeItemClassID:'',
          dis_count_percent_expression_1:"费用_金额*1.00",
          dis_count_percent_expression_2:"费用_金额*1.00",
          dis_count_percent_expression_3:"费用_金额*1.00",
          dis_count_percent_expression_4:"费用_金额*1.00",
          dis_count_percent_expression_5:"费用_金额*1.00",
          dis_count_percent_expression_6:"费用_金额*1.00",
          save_for_virtual:0,
          room_status_for_virtual:[],
          room_status_change_type_for_virtual:0,
          is_delay:0,
          rate:0,
          is_delay_days:1,
          derate_month_day:0,
          delay_mode:0,
          delay_begin_date:'',
        };
      }
      this.modal1axing = true;
    },
    //新增和修改保存
    oks(){
      if(this.dades.name == ""){
        this.$Message.error('名称不能为空!');
        this.loadingModals();
        return false;
      }
      if(this.dades.pindex_id == ""){
        this.$Message.error('项目不能为空!');
        this.loadingModals();
        return false;
      }
      if(this.dades.chargeItem_name_id == ""){
        this.$Message.error('收费类型不能为空!');
        this.loadingModals();
        return false;
      }
      if(this.dades.charge == ""){
        this.$Message.error('费用不能为空!');
        this.loadingModals();
        return false;
      }
      if(this.dades.type != 5){
        if(this.dades.charge1 == ""){
          this.$Message.error('税率不能为空!');
          this.loadingModals();
          return false;
        }
        if(this.dades.area == "" || this.dades.area == null){
          this.$Message.error('公式不能为空!');
          this.loadingModals();
          return false;
        }
      }
      if(this.dades.receivable == "" || this.dades.receivable == null){
        this.$Message.error('应收精确到具体不能为空!');
        this.loadingModals();
        return false;
      }
      if(this.dades.receivable_calculation == "" || this.dades.receivable_calculation == null){
        this.$Message.error('应收精确到尾数处理不能为空!');
        this.loadingModals();
        return false;
      }
      if(this.dades.receipts == "" || this.dades.receipts == null){
        this.$Message.error('实收精确到具体不能为空!');
        this.loadingModals();
        return false;
      }
      if(this.dades.receipts_calculation == "" || this.dades.receipts_calculation == null){
        this.$Message.error('实收精确到尾数处理不能为空!');
        this.loadingModals();
        return false;
      }
      this.$Loading.start();
      let fm_data=JSON.parse(JSON.stringify(this.dades));
      fm_data.room_status_for_virtual.length&&(fm_data.room_status_for_virtual=fm_data.room_status_for_virtual.join(','))
      this.$myhttp.post('admin/chargeAdd',fm_data,{
        'Content-Type': 'application/x-www-form-urlencoded'
        }).then(backdata=>{ // 异步执行成功后
          if(backdata.data[0] == 200){
            this.dela = true;
            this.$Message.success(backdata.data[1]);
            this.$Loading.finish();
            this.modal1axing = false;
            this.change(1);
          }
      });
    },
    // 按项目复制设置项目
    copySave(){
      this.$Loading.start();
      let fm_copy=JSON.parse(JSON.stringify(this.copyData));
      this.$myhttp.post('admin/chargeCopyAdd',fm_copy,{
        'Content-Type': 'application/x-www-form-urlencoded'
      }).then(backdata=>{ // 异步执行成功后
        this.loadingCopys();
        if(backdata.data.code == 200){
          this.$Message.success(backdata.data.msg);
          this.$Loading.finish();
          this.copy1axing = false;
          this.change(1);
        }else{
          this.$Message.error(backdata.data.msg);
        }
      });
    },
    //搜索
    searchs(){
      this.change(1);
    },
    //修改
    xiugai(e,s){
      this.$Loading.start();
      this.$myhttp.get('admin/getchangexiu?id='+e,{
        'Content-Type': 'application/json'
        }).then(backdata=>{ // 异步执行成功后
        backdata.data[0][0].room_status_for_virtual&&(backdata.data[0][0].room_status_for_virtual=backdata.data[0][0].room_status_for_virtual.split(','))
          this.dades = backdata.data[0][0];
          if(backdata.data[0][0]['fixed'] == 1){
            this.dades.pindex_id = "1";
          }
          this.cs =  backdata.data[2];
          this.dades.company_id =  backdata.data[3];
          this.modal1axing = true;
          // console.log(backdata.data[4]);
          this.$forceUpdate();
          var area =  backdata.data[4];
          let _this = this;
          setTimeout(function() {
          	_this.dades.area = area;
          }, 100);
          this.$Loading.finish();
      });
    },
    projectCopy(){
      this.copy1axing = true
    },
    //删除
    del(e){
      this.$Loading.start();
      this.$confirm('此操作将永久删除该项吗, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$myhttp.post('admin/chargeDelete',{id:e},{
            'Content-Type': 'application/x-www-form-urlencoded'
            }).then(backdata=>{ // 异步执行成功后
              if(backdata.data == 200){
                this.dela = true;
                this.$Message.success('删除成功!');
                this.change(1);
              } else if (backdata.data.code == 201) {
                this.$Message.error(backdata.data.msg);
              }
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
          this.$Loading.finish();
        });
    },
    //分页
    change(page){
      let type = "&ChargeItemInTypeID="+this.ChargeItemInTypeID+"&ChargeItemClassID="+this.ChargeItemClassID+"&ChargeitemNameId="+this.ChargeitemNameId;
      ERP.showLoading()
      this.$Loading.start();
      this.$myhttp.get('admin/charge?page='+page+'&search='+this.search+'&type='+this.activeName+'&pindex_id='+this.pindex_id+type,{
        'Content-Type': 'application/json'
        }).then(backdata=>{ // 异步执行成功后
          this.desserts = backdata.data[0];
          this.total = backdata.data[1];
          this.page = backdata.data[2];
          this.$Loading.finish();
        ERP.hideLoading()
      });
    },
    nodeClick(e){
      this.pindex_id=e.id;
      this.dades.pindex_id = e.id;
      this.change(1)
    },
    //弹窗不要关闭
    loadingModals(){
      let _this = this;
      _this.loadingModal=false;
      setTimeout(() => {
        _this.loadingModal = true;
      }, 10);
    },
    //弹窗不要关闭
    loadingCopys(){
      let _this = this;
      _this.loadingCopy=false;
      setTimeout(() => {
        _this.loadingCopy = true;
      }, 10);
    }
  },
  watch: {
      'dades.type'(val){
        this.dades.area="";
      },
      'dades.types'(val){
        this.dades.area="";
      },

  }
}
</script>
<style scoped>
.ti{
  margin: 1%;
  width: 98%;
}
.text1{
  text-align: center;
}
.pages{
  margin-top: 2%;
  margin-right: 3%;
  text-align: right;
}
.zhujie{
  margin-left: 14%;
  color: brown;
}
.search{
  margin-top: 0.2%;
  width: 20%;
  margin-bottom: 1.5%;
}
.text2{
  color: rgb(250, 248, 248);
}
.kuan{
  width: 12%;
}
.zhanwu{
  text-align: center;
  color: rgb(207, 205, 205);
  font-size: 20px;
  margin-top: 3%;
}
.text3{
  color: rgb(9, 145, 145);
}
.d-flex {
    display: flex;
  }

  .d-flex-left {
    margin-right: 10px;
    border-right: 1px solid #eee;
    padding-right: 10px;
  }

  .d-flex-right {
    flex: 1;
  }
</style>



// WEBPACK FOOTER //
// src/components/Admin/Project/Charge.vue